// src/components/layout/ChatColumn/LoadingDots.jsx
import React, { useCallback } from 'react';
import { XCircle } from 'lucide-react';

/* ========================
 * LoadingDots - Simple loading indicator with optional cancel button
 * ======================== */
const LoadingDots = ({ status, onCancel }) => {
  // Always animate unless explicitly cancelled or error
  const shouldAnimate = status !== 'cancelled' && status !== 'error';

  const handleCancelClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (typeof onCancel === 'function') {
      onCancel();
    }
  }, [onCancel]);
  
  return (
    <div className="inline-flex items-center py-0.5 group">
      <div className="flex items-center space-x-1.5">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            // ARCHITECTURAL FIX: Apply transition only when not animating to prevent CSS conflicts.
            // This ensures the `animate-pulse` keyframe animation is not competing with a `transition`
            // on the same `opacity` property, making behavior consistent across renders and reloads.
            className={`w-1.5 h-1.5 rounded-full bg-primary ${shouldAnimate ? 'animate-pulse' : 'opacity-90 transition-opacity duration-300'}`}
            style={{ 
              animationDelay: `${index * 0.2}s`,
              animationDuration: '1.5s',  
            }}
          />
        ))}
      </div>
      
      {/* Show cancel button for any active status */}
      {shouldAnimate && typeof onCancel === 'function' && (
        <div className="w-0 group-hover:w-6 overflow-hidden transition-all duration-200 ml-1">
          <button
            onClick={handleCancelClick}
            className="pl-2 text-on-surface-dim hover:text-on-surface transition-colors cursor-pointer"
            aria-label="Cancel response generation"
          >
            <XCircle className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default LoadingDots;